<script setup lang="ts">
defineProps({
  title: {
    type: String,
    default: 'Wirklich löschen?',
  },
  confirmText: {
    type: String,
    default: 'Löschen',
  },
})

defineEmits<{
  close: [boolean]
}>()
</script>

<template>
  <ConfirmModal :title="title" :confirm-text="confirmText" @close="$emit('close', $event)">
    <slot />
    <template #body>
      <slot name="body" />
    </template>
  </ConfirmModal>
</template>
